export default __webpack_public_path__ + "static/media/valores_.abd15faf.png";